import UserAvatarPlaceholder from "@/assets/images/user_avatar_placeholder.svg";
import clsxm from "@/lib/clsxm";
import {type FC} from "react";

const InfluencerMiniProfile: FC<{
  className?: string;
  id: number;
  image?: string | null;
  firstName?: string;
  textContainerClassName?: string;
  username?: string | null;
  usernameClassName?: string;
}> = ({className, id, image, firstName, textContainerClassName, username, usernameClassName}) => (
  <div
    onClick={e => {
      e.stopPropagation();
      window.open(`/influencer/${id}/`, "_blank");
    }}
    className={clsxm("z-10 flex cursor-pointer items-center gap-2", className)}>
    <img src={image ?? UserAvatarPlaceholder} className="size-7 shrink-0 rounded-full" />
    <div className={clsxm("text-neutral-black flex flex-col justify-center", textContainerClassName)}>
      <span className="text-sm leading-3 font-semibold">{firstName}</span>
      <span className={clsxm("text-2xs leading-3.5", usernameClassName)}>{username}</span>
    </div>
  </div>
);

export default InfluencerMiniProfile;
